import styled, { css, keyframes } from 'styled-components/macro';
import { DestinationLogo } from '@yme/assets/icons/destinations';
import { ButtonFaded } from '@yme/atoms/button/styled';
import { DropDownStyled, SimpleDropDown } from '@yme/atoms/dropdown/SimpleDropDown';
import { DropDownListWrapperStyled, SelectedOptionTitleStyled, } from '@yme/atoms/dropdown/SimpleDropDown/styled';
import { MiniButtonContent } from '@yme/atoms/mini-button';
import { MiniButtonStyled } from '@yme/atoms/mini-button/styled';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { STICKY_HEADER_HEIGHT_DEFAULT, STICKY_HEADER_HEIGHT_MOBILE, } from '@yme/components/Header/constants';
import { Link } from '@yme/components/Link';
import { colorBlackTransparent100, colorBlackTransparent300, colorBlackTransparent50, colorCoreBackground1000, colorCoreBlack900Base, colorCoreGray300, colorCoreGray500, colorCoreWhite1000, colorWhiteTransparent300, defaultTransparent, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { elevationBottomLvl4 } from '@yme/tokens/elevations';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel4, RegularTextLevel4 } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles, ellipsisEndingLine } from '@yme/utils/styles';
const slideDown = keyframes `
  from {
    top: 0;
  }

  to {
    top: ${STICKY_HEADER_HEIGHT_MOBILE}px;
    
    ${ADAPTIVE.minWidth.tablet} {
      top: ${STICKY_HEADER_HEIGHT_DEFAULT}px;
    }
  }
`;
export const ServiceButtonsContainerStyled = styled(FlexWrapper) `
  position: relative;
  margin-left: 13px;
  padding-left: 13px;

  ${ADAPTIVE.minWidth.desktop} {
    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      display: none;
      width: 2px;
      height: 17px;
      background-color: ${colorWhiteTransparent300};
      transform: translateY(-50%);
    }
  }
`;
export const NavListStyled = styled.ul `
  display: flex;
  flex: 1;
  align-items: center;
  flex-wrap: wrap;
  margin: ${({ isRightToLeft }) => (isRightToLeft ? '0 auto 0 0' : '0 0 0 auto')};
  padding: 0;
  box-sizing: border-box;
  list-style: none;
  overflow: hidden;
  justify-content: flex-end;

  ${ADAPTIVE.minWidth.desktop} {
    height: 32px;

    & + ${ServiceButtonsContainerStyled}::after {
      display: block;
    }
  }
`;
export const NavItemStyled = styled.li `
  &:not(:last-child) {
    ${({ isRightToLeft }) => (isRightToLeft ? 'margin-left' : 'margin-right')}: 4px;
  }
`;
export const NavLinkStyled = styled(Link) `
  display: block;
  padding: 6px 12px;
  border-radius: ${CORNER_RADIUS.xl};

  ${getTextStyles('Ubuntu', 500, 14, 20)}

  color: ${colorCoreWhite1000};
  text-decoration: none;
  white-space: nowrap;
  text-shadow: ${elevationBottomLvl4};

  ${({ isActive }) => isActive
    ? `
        background-color: ${colorBlackTransparent100};
        text-shadow: none;
        cursor: default;
      `
    : `
        &:hover {
          background-color: ${colorBlackTransparent50};
          text-shadow: none;
        }
      `}
`;
export const NavTitleStyled = styled.div `
  text-shadow: ${elevationBottomLvl4};
  padding: ${(isSwitcherItem) => (isSwitcherItem ? '0px 6px' : '6px 12px')};
  border-radius: ${CORNER_RADIUS.xl};

  ${(isSwitcherItem) => isSwitcherItem && 'width: 100%'};

  ${ADAPTIVE.minWidth.tablet} {
    padding: 6px 12px;

    ${(isSwitcherItem) => isSwitcherItem && 'width: calc(50% - 24px)'};
  }

  ${ADAPTIVE.minWidth.desktop} {
    ${(isSwitcherItem) => isSwitcherItem && 'width: initial'};
  }
`;
export const ImageWrapperStyled = styled.div `
  width: 202px;
  height: 45px;

  svg {
    width: 100%;
    height: 100%;
  }
`;
export const UpButtonStyled = styled(NavTitleStyled) `
  :hover {
    background-color: ${colorBlackTransparent50};
  }
  a {
    text-decoration: none;
    color: inherit;
  }
`;
export const UpButtonContainerMobileStyled = styled.div `
  ${ButtonFaded} {
    background-color: ${({ isClothingOrAccessoriesPDP }) => !isClothingOrAccessoriesPDP && `${colorCoreGray300}`};
  }
`;
export const NavTitleIconStyled = styled(SVGIcon) ``;
export const SwitcherIconStyled = styled(SVGIcon) `
  ${ADAPTIVE.maxWidth.mobile} {
    width: 18px;
    height: 18px;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  rect {
    fill: ${colorCoreWhite1000};
    fill-opacity: initial;
  }
`;
export const LinkStyled = styled(Link) `
  text-decoration: none;

  ${MiniButtonStyled} {
    text-shadow: ${elevationBottomLvl4};
  }
`;
export const DropDownControlStyled = styled(DropDownStyled) `
  height: auto;
  padding: 4px 10px 4px 12px;
  border: none;
  border-radius: ${CORNER_RADIUS.xl};

  background-color: ${({ isDropDownExpanded }) => isDropDownExpanded ? `${colorBlackTransparent50}` : `${defaultTransparent}`};

  &:hover {
    background-color: ${colorBlackTransparent50};
  }

  ${RegularTextLevel4} {
    ${getTextStyles('Play', 700, 14, 16)}

    text-transform: uppercase;
  }

  svg path {
    fill: ${colorCoreWhite1000};
  }
`;
const getPlnCommonStyles = (isDestinationPage) => css `
  ${NavLinkStyled}, ${NavTitleStyled}, ${SelectedOptionTitleStyled}, ${MiniButtonContent}, ${HeadingLevel4} {
    color: ${isDestinationPage ? colorCoreWhite1000 : colorCoreBlack900Base};
    text-shadow: none;
  }

  ${LinkStyled}, ${DropDownControlStyled} {
    ${!isDestinationPage &&
    css `
      svg path {
        fill: ${colorCoreBlack900Base};
      }
    `}
  }

  ${NavTitleIconStyled} {
    svg path {
      fill: ${colorBlackTransparent300};
    }
  }

  ${SwitcherIconStyled} {
    svg rect {
      fill: ${colorBlackTransparent300};
    }
  }
`;
export const FloatingContainerStyled = styled.div `
  top: ${({ headerHeight }) => `${headerHeight}px`};
  position: absolute;
  z-index: ${Z_INDEX.level7};
  width: 100%;
  ${({ isNavDarkModeEnabled }) => isNavDarkModeEnabled && `background-color: ${colorBlackTransparent300}`};

  ${({ isDestinationPage, isMenuOpen }) => isDestinationPage &&
    css `
      ${ADAPTIVE.maxWidth.tablet} {
        ${isMenuOpen && 'visibility: hidden'};

        ${SelectedOptionTitleStyled} {
          width: 160px;
          height: 36px;
          font-size: 0;
          background-image: url(${DestinationLogo});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    `}

  ${ADAPTIVE.minWidth.desktop} {
    ${SelectedOptionTitleStyled} {
      ${getTextStyles('Ubuntu', 500, 14, 20)}

      text-shadow: ${elevationBottomLvl4};
      text-transform: none;
    }
  }

  ${({ isClothingOrAccessoriesPDP, isDestinationPage }) => isClothingOrAccessoriesPDP &&
    css `
      background-color: ${colorCoreBackground1000};
      border-top: 1px solid;
      border-bottom: 1px solid;
      border-color: ${colorCoreGray500};

      ${getPlnCommonStyles(isDestinationPage)}
    `}

  ${({ isVisible, isDestinationPage }) => isVisible &&
    css `
      background-color: ${isDestinationPage ? colorCoreBlack900Base : colorCoreWhite1000};

      ${!isDestinationPage &&
        css `
        position: fixed;
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-color: ${colorCoreGray500};
        animation: ${slideDown} 0.2s ease-out;
      `}

      ${ServiceButtonsContainerStyled} {
        &:after {
          background-color: ${colorBlackTransparent300};
        }
      }

      ${getPlnCommonStyles(isDestinationPage)}
    `}

  ${DropDownListWrapperStyled} {
    width: max-content;
    min-width: 150px;
    max-width: 220px;
    left: 0;

    ${ADAPTIVE.minWidth.tablet} {
      min-width: 200px;
      max-width: 250px;
    }

    ${ADAPTIVE.minWidth.desktop} {
      left: initial;
      ${({ isDealerLocatorLinkExists }) => (isDealerLocatorLinkExists ? 'left: 0' : 'right: 0')};
      min-width: auto;
    }
  }
`;
export const SimpleDropDownStyled = styled(SimpleDropDown) `
  width: auto;
  max-width: 160px;

  ${ADAPTIVE.minWidth.tablet} {
    max-width: 200px;
  }

  ${ADAPTIVE.maxWidth.tablet} {
    max-width: ${(isDestinationPage) => isDestinationPage && 'max-content'};
  }
`;
export const SwitcherItemStyled = styled(FlexWrapper) `
  opacity: ${({ isActive }) => (isActive ? '1' : '0.4')};

  &:hover {
    opacity: 1;
  }
`;
export const NavSectionStyled = styled(FlexWrapper) `
  max-width: 40%;

  ${ADAPTIVE.minWidth.tablet} {
    max-width: 50%;
  }

  ${ADAPTIVE.minWidth.desktop} {
    max-width: initial;
  }
`;
export const NavSectionTitleStyled = styled(HeadingLevel4) `
  width: 100%;
  text-align: center;
  letter-spacing: 0;

  ${getTextStyles(null, null, 18, 24)};
  ${ellipsisEndingLine};

  ${ADAPTIVE.minWidth.tablet} {
    ${getTextStyles(null, null, 24, 28)};
  }
`;
export const NavSectionSubtitleStyled = styled(HeadingLevel4) `
  width: 100%;
  margin-top: -6px;
  text-align: center;
  letter-spacing: 0.1em;

  ${getTextStyles(null, 400, 10, 14)};
  ${ellipsisEndingLine};

  ${ADAPTIVE.minWidth.tablet} {
    ${getTextStyles(null, 400, 14, 20)};
  }
`;
